import React from "react";
import "../../styles/main.css";
import theme from "../../styles/theme";

import ContainerBase from "../../components/framepart/SubpageLayout/ContainerBase";
import GraphCanvas from "../../components/defined/minds/GraphCanvas";


/* ============================================================
   CONSTANTES DE LAYOUT (STABLES)
============================================================ */

const PAGE_PADDING = 6;
const CONTAINER_GAP = 0;



/* ============================================================
   PALETTE LOCALE — Minds (mi-nuit maîtrisé)
============================================================ */

const MINDS = "#5c4b6e";

/* Centre : monde émergent */
const CENTER_BG = "#27323f";
const CENTER_BORDER = "rgba(92,75,110,0.55)";

/* Panneaux latéraux : volets liés au centre */
const SIDE_BG = "#e9e7ef";              // dérivé clair / froid
const SIDE_BORDER = "rgba(92,75,110,0.25)";

/* ============================================================
   STYLES — Containers
============================================================ */


const baseContainerStyle = {
  minHeight: "calc(100vh - 220px)", // 🔒 NE PAS TOUCHER
  padding: 6,
  overflow: "auto",
  boxSizing: "border-box",
};

/* Zone gauche — Sources (volet) */
const leftZoneStyle = {
  ...baseContainerStyle,
  flex: "0 0 15%",
  minWidth: 220,
  maxWidth: 320,

  background: SIDE_BG,
  color: "#1f2933",

  borderTopLeftRadius: 6,
  borderBottomLeftRadius: 6,
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,

  border: `1px solid ${SIDE_BORDER}`,
  borderRight: "none", // continuité
};

/* Zone centrale — Monde émergent (cœur) */
const centerZoneStyle = {
  ...baseContainerStyle,
  flex: "1 1 65%",
  minWidth: 600,

  background: CENTER_BG,
  color: "#f3f4f6",

  borderRadius: 0,
  border: `1px solid ${CENTER_BORDER}`,

  scrollbarColor: `${MINDS} ${CENTER_BG}`,
};

/* Zone droite — Signaux (volet) */
const rightZoneStyle = {
  ...baseContainerStyle,
  flex: "0 0 20%",
  minWidth: 260,
  maxWidth: 420,

  background: SIDE_BG,
  color: "#1f2933",

  borderTopRightRadius: 6,
  borderBottomRightRadius: 6,
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,

  border: `1px solid ${SIDE_BORDER}`,
  borderLeft: "none", // continuité
};

/* ============================================================
   PAGE
============================================================ */

const Subpage_301 = () => {
  const zoneLeft = {
    style: leftZoneStyle,
    sections: [
      { title: "Sources", content: <div>Contenu à venir…</div> },
    ],
  };

  const mockElements = [
    { data: { id: "a", label: "A" } },
    { data: { id: "b", label: "B" } },
    { data: { id: "c", label: "C" } },
    { data: { source: "a", target: "b" } },
    { data: { source: "b", target: "c" } },
  ];

  const zoneCenter = {
    style: centerZoneStyle,
    sections: [
      {
        title: "Emergence",
        content: (
          <div style={{ height: "calc(100vh - 260px)" }}>
            <GraphCanvas elements={mockElements} />
          </div>
        ),

      },
    ],
  };

  const zoneRight = {
    style: rightZoneStyle,
    sections: [
      { title: "Signaux", content: <div>Agents / interprétation…</div> },
    ],
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <main
        style={{
          display: "flex",
          gap: CONTAINER_GAP,
          padding: PAGE_PADDING,
          width: "100%",
          height: "calc(100% - 50px)",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        <ContainerBase {...zoneLeft} />
        <ContainerBase {...zoneCenter} />
        <ContainerBase {...zoneRight} />
      </main>
    </div>
  );
};

export default Subpage_301;
